export type NavLink = { label: string; href: string; description?: string };

export type NavGroup = {
  id: string;
  label: string;
  links: NavLink[];
};

export const navGroups: NavGroup[] = [
  {
    id: 'about',
    label: 'Why Dany',
    links: [
      { label: 'What makes us different', href: '#why-dany', description: 'Family-owned, local, transparent' },
      { label: 'Reviews', href: '#reviews', description: 'What your neighbors are saying' },
      { label: 'Our promise', href: '#promise', description: 'Guaranteed work, no pressure' },
      { label: 'FAQ', href: '#faq', description: 'Answers to common questions' },
    ],
  },
  {
    id: 'services',
    label: 'Services',
    links: [
      { label: 'What we handle', href: '#services', description: 'Stone, concrete, lawn, drainage & more' },
      { label: 'Our work', href: '#our-work', description: 'Photos of real projects' },
      { label: 'Free estimate', href: '#estimate', description: 'No obligation, honest pricing' },
    ],
  },
];
